import cc from 'classcat';
import React from 'react';

type ButtonVariant = 'contained' | 'text' | 'bordered' | 'underline' | 'danger';
type ButtonColor = 'primary' | 'success' | 'error' | 'gray' | 'blue';

interface IButton {
    text: string;
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
    textClassName?: string;
    className?: string;
    variant?: ButtonVariant;
    isSubmit?: boolean;
    color?: ButtonColor;
    disabled?: boolean;
    iconSrc?: string;
    iconRight?: string;
    iconLeftNode?: React.ReactNode;
    iconRightNode?: React.ReactNode;
    testId?: string;
}

export const Button = ({
    textClassName,
    className,
    onClick,
    text,
    isSubmit,
    disabled,
    variant = 'contained',
    color = 'primary',
    iconSrc,
    iconRight,
    iconLeftNode,
    iconRightNode,
    testId,
}: IButton) => {
    return (
        <button
            type={isSubmit ? 'submit' : 'button'}
            onClick={onClick}
            disabled={disabled}
            className={cc([
                'button-style',
                `button-style--${variant}`,
                `button-style--${variant}--${color}`,
                { 'button-style--with-icon': iconSrc || iconRight || iconLeftNode || iconRightNode },
                className,
            ])}
            data-testid={testId}
        >
            {iconSrc && <img src={iconSrc} alt="icon-left" />}
            {iconLeftNode && <span className="button-icon-left">{iconLeftNode}</span>}
            <p className={textClassName || 'paragraph-3'}>{text}</p>
            {iconRight && <img src={iconRight} alt="icon-right" />}
            {iconRightNode && <span className="button-icon-right">{iconRightNode}</span>}
        </button>
    );
};
